<!-- 
<div class="col-md-6 d-inline-flex mb-4">
    <div class="field-input w-100">
        <label class="form-labels">{{field.label}}</label> <label *ngIf="field.required" class="text-danger">*</label>
        <mat-form-field floatLabel="never" class="form-control" [formGroup]="group">
            <input matInput [matDatepicker]="picker" [formControlName]="field.name" [placeholder]="field.label">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-hint></mat-hint>
            <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
                <mat-error *ngIf="group.get(field.name).hasError(validation.name)" style="font-size: 12px;margin-top: 2px;">{{validation.message}}</mat-error>
            </ng-container>
        </mat-form-field>
    </div>
</div> -->

<div class="{{(field.containerClass ? field.containerClass : 'col-md-6 d-inline-flex mb-4')}}">
    <div class="field-input w-100">
        <label class="form-labels">{{field.label}}<span *ngIf="field.required" class="text-danger">*</span></label>
        <div [formGroup]="group">
            <input [ngClass]="{'disabled': field.disabled}" [disabled]="field.disabled" type="date" [formControlName]="field.name" class="form-control" [placeholder]="field.placeholder"
                [type]="field.inputType" />

        </div>
        <div *ngFor="let validation of field.validations">
            <div *ngIf="group.get(field.name).invalid && (group.get(field.name).dirty || group.get(field.name).touched)"
                class="text-danger">
                <small *ngIf="group.get(field.name).errors">
                    <b>
                        *{{validation.message}}
                    </b>
                </small>
            </div>
        </div>
    </div>
</div>